module.exports = "<span uib-dropdown auto-close=\"outsideClick\" is-open=\"$ctrl.isOpen\"><p class=\"input-group\"><input ng-model=\"$ctrl.field\" uib-datepicker-popup=\"shortTime\" class=\"form-control\"></p></span>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/jade-html-loader!./app/common/widgets/datePickers/timeField.jade
// module id = 559
// module chunks = 0